import React from 'react';
import TreatmentConsentLandingPage from './TreatmentConsentLandingPage';

export default function ImplantConsentFormUk() {
  return (
    <TreatmentConsentLandingPage
      title="Implant Consent Form UK | AI Dental Consent Forms | Smile Consent"
      description="Create an implant consent form for UK dental practices with AI-assisted drafting, digital signing, and audit trails for risks, alternatives, and aftercare."
      canonicalUrl="https://smileconsent.co.uk/implant-consent-form-uk"
      h1="Implant Consent Form for UK Practices"
      treatmentName="Implant consent form"
      intro="Create a clearer implant consent form for UK patients with risks, alternatives, costs, healing expectations, and digital signing in one workflow."
      risks={[
        'Treatment benefits, likely outcomes, and the option of no treatment.',
        'Material risks such as implant failure, infection, nerve injury, sinus involvement, and the need for further treatment.',
        'Alternatives including bridges, dentures, or delaying treatment where clinically relevant.',
        'Healing times, review appointments, oral hygiene expectations, and likely aftercare.',
        'Itemised treatment costs, staged treatment planning, and possible additional procedures such as grafting.',
      ]}
      relatedLinks={[
        { title: 'Orthodontic consent form UK', description: 'Consent wording for orthodontic treatment', path: '/orthodontic-consent-form-uk' },
        { title: 'Tooth extraction consent form UK', description: 'Consent records for routine and surgical extraction', path: '/tooth-extraction-consent-form-uk' },
        { title: 'AI dental consent forms', description: 'See all treatment-specific consent workflows', path: '/dental-consent-forms' },
      ]}
    />
  );
}
